module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/tactical-training.ab48aadd.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/tactical-training.png
// module id = 3751
// module chunks = 11